import React from 'react'
import styled from "styled-components";
import { CircularProgress } from "@mui/material";

export default function ModalCarregandoDadosTrackId() {
  return (
    <Modal id="modal-loading-trackid">
      <ModalBox open>
        <p>Aguarde, estamos buscando suas informações...</p>
        <CircularProgress size={20} />
      </ModalBox>
    </Modal>
  )
}

const Modal = styled.div`
  background-color: rgba(0, 0, 0, .3);
  position: fixed;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  
  opacity: 0;
  &.visible {
    pointer-events: auto;
    opacity: 1;
  }

  transition: all .3s;
`;

const ModalBox = styled.dialog`
  backdrop-filter: blur(5px);
  border-radius: 4px;
  background-color: #fff;
  padding: 2rem;

  p {
    margin: 0;
    text-align: center;
    cursor: text;
  }
  
  display: flex;
  align-items: center;
  justify-content: center;
  gap: .8rem;
  max-width: 20rem;
  border: none;
  flex-direction: column;
`;